import { login } from '@/api/basic'
import { getCookie, setCookie, removeCookie } from '@/utils/auth'
import { timestampToTime3 } from '@/utils/timestamp'

const user = {
  state: {
    token: getCookie('token'),
    name: getCookie('name') // 姓名
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    }
  },

  actions: {
    // 用户密码登录
    Login ({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data.loginname, data.password).then(response => {
          setCookie('token', response.access_token, 2)
          setCookie('name', response.name)
          setCookie('tokentime', timestampToTime3(new Date()))
          commit('SET_TOKEN', response.access_token)
          commit('SET_NAME', response.name)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeCookie('token')
        removeCookie('name')
        removeCookie('tokentime')
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js